<div class="grid-container" *ngIf="isBanner" [class.arebic-content]="textDirection == 'rtl'" >
    <div class="grid-item form">
      <div class="pd-20">
        <taly-request-form />
      </div>
       
    </div>
    <div class="grid-item banner">
      <div class="pd-20">
        <taly-business-with-taly />
      </div>
        <!-- <img src="assets/images/Business-request-form.svg" /> -->
    </div>
</div>

<div class="thank-you-main" *ngIf="isThankyou">
  <div class="thank-you-title">
    <img src="assets/images/payment-success.svg" alt="Success image">
    <h4 translate>THANK_YOU</h4>
    <p translate>GET_BACK</p>
    <div class="close">  
      <button class="btn btn-sky-blue wt-100" routerLink="/partners" type="button" translate>
        CLOSE
      </button>
    </div>
  </div>
</div>
<div class="thank-you-main" *ngIf="isError">
  <div class="thank-you-title">
    <img src="assets/images/reject-logo.svg" alt="Error">
    <h4 translate>LEARN_MORE_PAGE.SOMETHING_WRONG</h4>
    <p translate>COMMON.SORRY_INCONVENINECe</p>
    <div class="close">  
      <button class="btn btn-sky-blue wt-100" (click)="tryAgain()" type="button" translate>
        <img src="assets/images/back-arrow-icon.svg" alt="try-again">
        COMMON.CREATE_NEWFORM
      </button>
    </div>
  </div>
</div>